import { makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import ILocationAPIObject from "../../interfaces/ILocationAPI";
import { ComponentPermissions } from "../../Permissions";
import IVenue from "../../yoello-lib/modules/API/interfaces/IVenue";
import { DisableComponents } from "../util/DisableComponentsWrapper";
import { CreateVenueButton } from "./CreateVenueButton";
import { VenueTitle } from "./VenueTitle";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import { OnboardingSources } from "../signup/types";
import { PaymentProcessor } from "../menu/payments/types.d";

const useStyles = makeStyles({
  root: {
    textAlign: "center",
    paddingBottom: "1rem",
    borderBottom: "1px solid #E8EAF4",
  },
  title: {
    fontWeight: 700,
    fontSize: "1.125rem",
    marginBottom: "0.75rem",
  },
  text: {
    fontWeight: 600,
    fontSize: "0.8rem",
    color: "#757575",
  },
  img: {
    width: "5rem",
    height: "5rem",
    borderRadius: "0.5rem",
  },
  btn: {
    marginTop: "1rem",
  },
});

interface IVenueProfileView {
  venue: IVenue;
  location: ILocationAPIObject;
  isLoading?: boolean;
  onClickOveriew: () => void;
  history:any
}
export function VenueProfileView({
  venue,
  location,
  onClickOveriew,
  isLoading = false,
  history
}: IVenueProfileView) {
  const merchant = useSelector((state: IReduxAppState) => state.merchant);

  const classNames = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classNames.root}>
      {isLoading ? (
        <Skeleton variant='rect' className={classNames.img} animation='wave' />
      ) : (
        venue.url_logo && (
          <img
            alt='selected venue imgs'
            className={classNames.img}
            src={venue.url_logo}
          />
        )
      )}
      <VenueTitle location={location} venue={venue} isLoading={isLoading} />
      {(venue?.payment_processor !== PaymentProcessor.SQUARE || merchant.superuser) && (
        <Button
          className={classNames.btn}
          variant='outlined'
          onClick={onClickOveriew}
          data-component-name='All_Venues_Overview'
        >
          {t("venueSelection.overview")}
        </Button>
      )}
      {venue?.onboarding_source !== OnboardingSources.worldpay && (
        <DisableComponents
          disabledPermissions={ComponentPermissions.newVenueButton as any}
        >
          <CreateVenueButton history={history}/>
        </DisableComponents>
      )}
    </div>
  );
}
